const defaultAlphabet = [
  { ua: 'зг', en: 'zgh' },
  { ua: 'Зг', en: 'Zgh' },
  { ua: 'а', en: 'a' },
  { ua: 'А', en: 'A' },
  { ua: 'б', en: 'b' },
  { ua: 'Б', en: 'B' },
  { ua: 'в', en: 'v' },
  { ua: 'В', en: 'V' },
  { ua: 'г', en: 'h' },
  { ua: 'Г', en: 'H' },
  { ua: 'ґ', en: 'g' },
  { ua: 'Ґ', en: 'G' },
  { ua: 'д', en: 'd' },
  { ua: 'Д', en: 'D' },
  { ua: 'е', en: 'e' },
  { ua: 'Е', en: 'E' },
  { ua: 'ж', en: 'zh' },
  { ua: 'Ж', en: 'Zh' },
  { ua: 'з', en: 'z' },
  { ua: 'З', en: 'Z' },
  { ua: 'и', en: 'y' },
  { ua: 'И', en: 'Y' },
  { ua: 'й', en: 'i' },
  { ua: 'Й', en: 'Y' },
  { ua: 'к', en: 'k' },
  { ua: 'К', en: 'K' },
  { ua: 'л', en: 'l' },
  { ua: 'Л', en: 'L' },
  { ua: 'м', en: 'm' },
  { ua: 'М', en: 'M' },
  { ua: 'н', en: 'n' },
  { ua: 'Н', en: 'N' },
  { ua: 'о', en: 'o' },
  { ua: 'О', en: 'O' },
  { ua: 'п', en: 'p' },
  { ua: 'П', en: 'P' },
  { ua: 'р', en: 'r' },
  { ua: 'Р', en: 'R' },
  { ua: 'с', en: 's' },
  { ua: 'С', en: 'S' },
  { ua: 'т', en: 't' },
  { ua: 'Т', en: 'T' },
  { ua: 'у', en: 'u' },
  { ua: 'У', en: 'U' },
  { ua: 'ф', en: 'f' },
  { ua: 'Ф', en: 'F' },
  { ua: 'х', en: 'kh' },
  { ua: 'Х', en: 'Kh' },
  { ua: 'ц', en: 'ts' },
  { ua: 'Ц', en: 'Ts' },
  { ua: 'ч', en: 'ch' },
  { ua: 'Ч', en: 'Ch' },
  { ua: 'ш', en: 'sh' },
  { ua: 'Ш', en: 'Sh' },
  { ua: 'щ', en: 'shch' },
  { ua: 'Щ', en: 'Shch' },
  { ua: 'ъ', en: '' },
  { ua: 'Ъ', en: '' },
  { ua: 'ы', en: 'y' },
  { ua: 'Ы', en: 'Y' },
  { ua: 'ь', en: '' },
  { ua: 'Ь', en: '' },
  { ua: 'э', en: 'e' },
  { ua: 'Э', en: 'E' },
  { ua: 'ю', en: 'iu' },
  { ua: 'Ю', en: 'Yu' },
  { ua: 'я', en: 'ia' },
  { ua: 'Я', en: 'Ya' },
  { ua: 'і', en: 'i' },
  { ua: 'І', en: 'I' },
  { ua: 'ї', en: 'i' },
  { ua: 'Ї', en: 'Yi' },
  { ua: 'є', en: 'ie' },
  { ua: 'Є', en: 'Ye' },

  // Non literal symbols
  { ua: "'", en: '' },
  { ua: '`', en: '' },
];

export const InternationalInvoiceTranslitDictionary = [
  ...defaultAlphabet,
];

export const SmsServiceTranslitDictionary = [
  ...defaultAlphabet,
  { ua: '№', en: '#' },
];
